const requireheadtitle = require.context('../headtitle', false, /\.vue$/)
const requirescopetitle = require.context('../scopetitle', false, /\.vue$/)
const requirescopbottom = require.context('../scopebottom', false, /\.vue$/)
const requirescope = require.context('../scope', false, /\.vue$/);
const requireComponent = require.context('../template', false, /\.vue$/);
const requirecentertitle = require.context('../centertitle', false, /\.vue$/)
const requirescopetitlewidth = require.context('../scopetitlewidth', false, /\.vue$/)
import { getZjSort, getZjLevel, getZujian_list, update_pro, ZujianTb_list, ZujianLbl_list, prodataupdate, getprodata, userZjadd, userZjUpdate, getZjData, getZjExcel, getMyComp, updateMyConfig, prologdataupdate, getprologdata, getLevelByIds, getprologdatashare } from '@/api/new'
import screenfull from 'screenfull'
import { startRecording } from '@/utils/video.js'

// 页面加载进度条
export function progressCallback(progress) {
    this.progress = progress * 100
}
// 页面加载时...动态
export function addpoint() {
    if (this.point !== '...') {
        this.point += '.'
    } else {
        this.point = ''
    }
}
// 提前预加载组件
export function loadAllcomponents() {
    const componentshead = requireheadtitle.keys().map(key => requireheadtitle(key))
    const loadhead = componentshead.map(component => component.default)
    this.componenthead = loadhead

    const componentscopetitle = requirescopetitle.keys().map(key => requirescopetitle(key))
    const loadscopetitle = componentscopetitle.map(component => component.default)
    this.componentscopetitle = loadscopetitle

    const componentscope = requirescope.keys().map(key => requirescope(key))
    const loadscope = componentscope.map(component => component.default)
    this.componentscope = loadscope

    const compcenter = requirecentertitle.keys().map(key => requirecentertitle(key))
    const loadcenter = compcenter.map(component => component.default)
    this.compcentertitle = loadcenter

    const compscopetitlewidth = requirescopetitlewidth.keys().map(key => requirescopetitlewidth(key))
    const loadscopetitlewidth = compscopetitlewidth.map(component => component.default)
    this.compscopetitlewidth = loadscopetitlewidth
    

    // 获取底座
    const componentbottom = requirescopbottom.keys().map(key => requirescopbottom(key))
    const loadbottom = componentbottom.map(component => component.default)
    this.componentbottom = loadbottom

    const components = requireComponent.keys().map(key => requireComponent(key))
    // 将组件模块转换为可渲染的形式
    const loadedComponents = components.map(component => component.default)
    // 将组件模块转换为可渲染的形式
    this.loadedComponents = loadedComponents
}
// 通过本地id搜索组件并返回展示
export function getComp(name, type) {
    let comp = ''
    if (type == 'head') {
        comp = this.componenthead.find(item => item.name == name)
    } else if (type == 'scopetitle') {
        comp = this.componentscopetitle.find(item => item.name == name)
    } else if (type == 'scope') {
        comp = this.componentscope.find(item => item.name == name)
    } else if (type == 'bottom') {
        comp = this.componentbottom.find(item => item.name == name)
    } else if (type == 'largetitle') {
        comp = this.compcentertitle.find(item => item.name == name)
    } else if (type == 'widthTitle') {
        comp = this.compscopetitlewidth.find(item => item.name == name)
    } else {
        comp = this.loadedComponents.find(item => item.name == name)
    }    
    return comp
}
// 标题修改
export function submit(scope, index) {
    if (scope == 'headedit') {
        this.toptitle = this.formdata.toptitle
        this.tempdata.title = this.formdata.toptitle
        this.topEditS = false
    } else if (scope == 'scopeedit') {
        this.scopetitlelist[index].title = this.formdata.scopetitle
        this.formdata.scopetitle = ''
        this.topEditScope = false
    }
}
// 模板/组件 编辑完成时点击关闭按钮事件
export function editclose() {
    if (this.topEditS || this.topEditScope) {
        this.finalclose()
        return
    }
    this.$confirm('更换组件后数据将被重置为默认数据，是否保存当前组件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            if (this.LblComp) {
                if (this.activeid) {
                    this.tempdata.component_tb = this.activeid.toString()
                }
                if (this.activeid1) {
                    this.tempdata.component_lbl = this.activeid1.toString()
                }
                this.tempdata = { ...this.tempdata }
                this.savepro()
            }
            if (this.editScope) {
                let vitem = {
                    project_id: this.proid,
                    component_index: this.scopeindex + 1,
                    page: 1,
                    config_json: '',
                    totalpage: 1
                }
                this.requestList.push(vitem)
            }
            this.finalclose()
        })
        .catch(() => {
            if (this.editScope) {
                this.scopename[this.scopeindex] = this.oldscope
                this.scopename = [...this.scopename]
            }
            if (this.LblComp) {
                this.scopeactive = this.oldscope
                this.topactive = this.headold
            }
            this.finalclose()
        })
}
// 完成关闭
export function finalclose() {
    this.topEditS = false
    this.topEditScope = false
    this.editScope = false
    this.topComp = false
    this.LblComp = false
}
// 全屏
export function screen() {
    if (!screenfull.enabled) {
        return false
    }
    screenfull.toggle()
}
// 打开标题编辑弹窗
export function openScopeTitle(index) {
    
    this.titleindex = index
    this.formdata.scopetitle = this.scopetitlelist[index].title
    console.log( this.formdata.scopetitle,index);
    this.topEditScope = true
}
// 打开头部标题编辑弹窗
export function editHeadtitle() {
    this.formdata.toptitle = this.tempdata.title || this.tempdata.name
    this.topEditS = true
}
// 打开组件更换弹窗
export function openScope(index) {
    this.scopeindex = index
    let old = JSON.stringify(this.scopename[index])
    this.oldscope = JSON.parse(old)
    this.scopename[index].vdata = []
    this.scopename[index].jsondata = []
    let activescope = this.totalscop.find(item => item.id == this.scopename[index].id)
    this.levelactive = activescope.level_id
    this.sortselect = activescope.sort_id
    this.getZujian()
    this.editScope = true
}
// 打开组件对应excel
export async function opendata(i, type) {
    let vindex = i
    this.isexcel = false
    this.activescope = vindex
    const comname = 'comp' + i
    const dom = this.$refs[comname]
    let vdom = {}
    if (dom && dom.length) {
        vdom = dom[0]
    } else {
        vdom = dom
    }
    const defaultdata = vdom.defaultdata
    const valueMap = vdom.valueMap
    if (!defaultdata) {
        this.$message('该组件暂不支持数据更新')
        return
    }
    let exceldata = []
    this.exceltdata = this.scopename[vindex].jsondata
    this.apidata = this.scopename[vindex].apiconfig
    this.isApi = this.scopename[vindex].isApi
    this.selectcope = this.scopename[vindex]
    this.selectcope.valueMap = valueMap
    if (!this.exceltdata || !this.exceltdata.length) {
        if (type !== 2) {
            this.exceltdata = ''
            let vitem = {
                component_index: '',
            }
            vitem.component_index = vindex + 1
            let index = this.getdataList.findIndex(item => item.component_index == vitem.component_index)
            if (index == -1) {
                this.scopename[vindex].per = 0
                this.scopename[vindex].isloading = true
                this.getdataList.push(vitem)
            }
            return
        } else {
            if (vdom.exceldata && vdom.exceldata.length) {
                exceldata = vdom.exceldata
                this.scopename[vindex].isexcel = true
            } else {
                exceldata = defaultdata.map(item => {
                    let vitem = {}
                    valueMap.forEach(del => {
                        vitem[del.name] = item[del.key]
                    })
                    return vitem
                })
            }
            this.scopename[vindex].jsondata = exceldata
            this.scopename[vindex].isexcel = false
            this.scopename = [...this.scopename]
        }
    } else {
        this.isexcel = this.scopename[vindex].isexcel
        this.selectdom = vdom
        this.showdataEdit = true
    }
}
//组件列表分页点击事件
export function componentPageChange(currentPage) {
    this.currentPage = currentPage;
    this.getZujian()
}
// 组件列表分类切换
export function menuclick(item, type) {
    this.currentPage = 1
    if (type == 1) {
        this.sortactive = item.id
    } else {
        this.levelactive = item.id
    }
    this.getZujian()
}
// 关闭excel
export function closeSheet(vdata, exceldata, config, isApi) {
    if (!vdata) {
        this.showdataEdit = false
        return
    }
    let newdata = []
    const dom = this.selectdom
    let newdata1 = JSON.stringify(exceldata)
    let newdata2 = JSON.parse(newdata1)
    if (dom.isList) {
        let datamap = newdata2[0].data[0]
        datamap = datamap.filter(item => item && item !== null)
        const valuemap = datamap.map((item, i) => {
            const vitem = {
                name: item.v,
                key: `value${i + 1}`
            }
            return vitem
        })
        dom.valueMap = valuemap
    }
    const valueMap = dom.valueMap
    if (vdata && vdata.length) {
        newdata = vdata.map(item => {
            let vitem = {}
            valueMap.forEach(del => {
                vitem[del.key] = item[del.name]
            })
            return vitem
        })
    }
    let data3 = newdata2.map(item => {
        item.celldata = []
        item.visibledatarow = []
        item.visibledatacolumn = []
        item.config = {}
        item.data = item.data.map(arr => {
            let newarr = arr.filter((del, index) => (del && del !== null) || index < 12)
            return newarr
        })
        item.data = item.data.filter((del, index) => (del && del.length) || index < 20)
        return item
    })
    this.scopename[this.activescope].jsondata = data3
    this.scopename[this.activescope].vdata = newdata
    this.scopename[this.activescope].per = 0
    this.scopename[this.activescope].uploading = true
    this.scopename[this.activescope].valueMap = valueMap
    this.scopename[this.activescope].apiconfig = config
    this.scopename[this.activescope].isApi = isApi
    if (dom.setData) {
        dom.setData()
    }
    if (this.scopename[this.activescope].issave && this.scopename[this.activescope].saveid) {
        let config = JSON.parse(JSON.stringify(this.scopename[this.activescope]))
        config.jsondata = ""
        config.uploading = false
        const configparams = {
            id: this.scopename[this.activescope].saveid,
            component_config: JSON.stringify(config),
            name: this.scopename[this.activescope].name
        }
        updateMyConfig(configparams)
        this.saveProComp(data3, this.activescope + 1, this.scopename[this.activescope].saveid)
    } else {
        this.saveProComp(data3, this.activescope + 1)
    }
    this.showdataEdit = false
}
// 组件更换预览
export async function changeComp(item) {
    if (this.editScope) {
        if (this.sortactive == 9999) {
            if (!await this.getPermision(2)) {
				return;
			}
            this.scopename[this.scopeindex].compid = item.zujian_component_id
            this.scopename[this.scopeindex].vdata = []
            this.scopename[this.scopeindex].issave = true
            this.scopename[this.scopeindex].saveid = item.id
            const zjParams = {
                id: item.id
            }
            getZjData(zjParams).then(del => {
                if (del.status == 200) {
                    this.scopename[this.scopeindex] = JSON.parse(del.data.component_config)
                    this.scopename = [...this.scopename]
                }
            })
        } else if (item.component_id.includes('template')) {
            if (this.sortselect !== item.sort_id) {
                this.scopename[this.scopeindex].vdata = []
            }
            this.scopename[this.scopeindex].compid = item.component_id
            this.scopename[this.scopeindex].is_vip = item.is_vip
            this.scopename[this.scopeindex].issave = false
            this.scopename[this.scopeindex].saveid = ''
            this.scopename[this.scopeindex].id = item.id
            this.scopename = [...this.scopename]
        } else {
            this.$message('该组件未支持更换')
            return
        }
    }
    if (this.LblComp) {
        if (this.sortactive == 0) {
            if (item.local_id.includes('temhead')) {
                this.topactive = item.local_id
                this.activeid = item.id
            } else {
                this.$message('该头尾套件未支持更换')
                return
            }
        } else {
            if (item.local_id.includes('title')) {
                this.scopeactive = item.local_id
                this.activeid1 = item.id
            } else {
                this.$message('该标签组件未支持更换')
                return
            }
        }
    }
}
// 保存项目
export function savepro() {
    let newcomp = JSON.parse(JSON.stringify(this.scopename))
    newcomp.forEach((item, i) => {
        item.jsondata = ''
        if (this.scopetitlelist[i]) {
            item.name = this.scopetitlelist[i].title
        }
    })
    const params = {
        ...this.tempdata,
        config_json: JSON.stringify(newcomp),
    }
    update_pro(params).then(res => {
        // this.$router.push('/')
        this.$message.success('项目配置更新成功')
    })
}
// 初始化组件分类
export function getsort() {
    getZjSort().then(res => {
        this.sortlist = [{ name: '全部', id: 0 }, ...res.data, { name: '我的组件', id: 9999 }]
    })
}
export function getLevel() {
    getZjLevel().then(res => {
        this.levellist = [{ name: '全部', id: 0 }, ...res.data]
    })
}
export function selectinit() {
    this.getsort()
    this.getAllZujian()
}
// 获取组件列表
export function getZujian() {
    const params = {
        page: this.currentPage,
        limit: 8,
        sort: this.sortactive,
        level: this.levelactive
    }
    this.zujianloading = true
    let method = null
    if (this.LblComp) {
        if (this.sortactive == 0) {
            method = ZujianTb_list
        } else {
            method = ZujianLbl_list
        }
    } else if (this.sortactive == 9999) {
        method = getMyComp
    } else {
        method = getZujian_list
    }
    method(params).then(res => {
        this.Zujianlist = res.data
        this.pagetotal = res.count
        this.zujianloading = false
    })
}
// 一次性获取所有组件
export function getAllZujian() {
    const params = {
        page: 1,
        limit: 9999
    }
    getZujian_list(params).then(res => {
        this.totalscop = res.data
    })
}
// 项目预览
export async function preview() {
    const routeData = this.$router.resolve({
        name: 'editnew', // 目标路由的名称
        query: {
            projectId: this.proid,
            preview: 1
        }
    });
    window.open(routeData.href, '_blank');
}
// 回退到上一页
export function routeback() {
    this.$router.go(-1)
}
// 回到首页
export function logout() {
    this.$router.push('/')
}
// 更新组件数据
export function upCompdata() {
    if (this.requestList && this.requestList.length) {
        this.showup = true
        const vdata = this.requestList[this.upindex - 1]
        const upmethod = vdata.issave ? userZjUpdate : prodataupdate
        upmethod(vdata).then(res => {
            let index = ''
            index = vdata.component_index - 1
            this.scopename[index].per = (vdata.page / vdata.totalpage * 100).toFixed(0)
            if (vdata.page == vdata.totalpage) {
                this.scopename[index].uploading = false
            }
            this.scopename = [...this.scopename]
            if (res.status == 200) {
                if (vdata.page == vdata.totalpage) {
                    if (!vdata.excelchange) {
                        this.scopename[index].isexcel = true
                    }
                }
            }
            if (this.upindex < this.requestList.length) {
                this.upindex += 1
                this.upCompdata()
            } else {
                setTimeout(() => {
                    this.showup = false
                }, 500);
                this.upindex = 1
                this.requestList = []
                this.savepro()
            }
        })
    }
}
// 获取组件数据
export function getCompdata() {
    if (this.getdataList && this.getdataList.length) {
        this.showper = true
        let select = this.getdataList[this.getindex]
        this.scopename[select.component_index - 1].isloading = true
        let vdata = {
            project_id: this.proid,
            component_index: select.component_index,
            page: this.curindex,
        }
        if (this.curindex == 1) {
            this.percent = 0
        }
        let getmethod = getprodata
        if (this.scopename[select.component_index - 1].issave) {
            getmethod = getZjExcel
            vdata = {
                id: this.scopename[select.component_index - 1].saveid,
                page: this.curindex,
            }
        }
        getmethod(vdata).then(res => {
            if (res.status == 200) {
                this.scopename[select.component_index - 1].per = (this.curindex / res.total * 100).toFixed(0)
                this.scopename = [...this.scopename]
                if (this.curindex < res.total) {
                    this.curindex += 1
                    this.selectdata += res.data.config_json
                    this.getCompdata()
                } else {
                    this.scopename[select.component_index - 1].isloading = false
                    this.selectdata += res.data.config_json
                    let newdata = ''
                    if (this.selectdata) {
                        newdata = JSON.parse(this.selectdata)
                    }
                    this.scopename[select.component_index - 1].jsondata = newdata
                    this.selectdata = ''
                    if (newdata) {
                        this.scopename[select.component_index - 1].isexcel = true
                        setTimeout(() => {
                            if (this.getindex + 1 < this.getdataList.length) {
                                this.getindex += 1
                                this.curindex = 1
                                this.getCompdata()
                            } else {
                                this.getindex = 0
                                this.curindex = 1
                                this.getdataList = []
                                this.showper = false
                            }
                        }, 500);
                    } else {
                        setTimeout(() => {
                            if (this.getindex + 1 < this.getdataList.length) {
                                this.getindex += 1
                                this.curindex = 1
                                this.getCompdata()
                            } else {
                                this.getindex = 0
                                this.curindex = 1
                                this.getdataList = []
                                this.showper = false
                            }
                            this.opendata(select.component_index - 1, 2)
                        }, 500);
                    }
                }
            } else if (res.status == -1) {
                this.scopename[select.component_index - 1].isloading = false
                setTimeout(() => {
                    if (this.getindex + 1 < this.getdataList.length) {
                        this.getindex += 1
                        this.curindex = 1
                        this.getCompdata()
                    } else {
                        this.getindex = 0
                        this.curindex = 1
                        this.getdataList = []
                        this.showper = false
                    }
                }, 500);
                this.opendata(select.component_index - 1, 2)
            }
        })
    }
}
// 保存组件数据
export function saveProComp(vdata, index, id, type) {
    const newdata = this.getNewdata(JSON.stringify(vdata))
    let saveconfig = {}
    if (id) {
        saveconfig.issave = true
        saveconfig.id = id
    }
    newdata.forEach((item, i) => {
        let vitem = {
            excelchange: type,
            project_id: this.proid,
            component_index: index,
            page: i + 1,
            config_json: item,
            totalpage: newdata.length,
            ...saveconfig
        }
        this.requestList.push(vitem)
    })
}
// 数据分段处理
export function getNewdata(vdata) {
    const chucks = []
    for (let i = 0; i < vdata.length; i += this.maxLength) {
        const chunk = vdata.slice(i, i + this.maxLength);
        chucks.push(chunk)
    }
    return chucks
}
// 添加组件至我的收藏
export async function handlechange(e, index) {
    let item = this.scopename[index]
    item.issave = !e
    if (!await this.getPermision(2)) {
        return;
    }
    item.issave = !e
    if (!item.jsondata) {
        this.$message('请先进行组件数据下载后，再进行保存')
        return
    }
    if (e) {
        this.$confirm('是否将该组件保存至我的组件', '提示').then(res => {
            const zjdata = {
                zujian_id: item.id,
                name: item.name,
                component_config: 'config'
            }
            userZjadd(zjdata).then(res => {
                const saveid = res.data.id
                item.issave = true
                item.saveid = saveid
                let zdata = JSON.parse(JSON.stringify(item))
                zdata.jsondata = ""
                zjdata.id = saveid
                zjdata.component_config = JSON.stringify(zdata)
                updateMyConfig(zjdata)
                this.saveZj(saveid, index)
            })
        })
            .catch(res => {
                return
            })
    } else {
        this.$confirm('取消收藏后，当前组件将与我的组件移出数据同步功能，再次收藏本组件将会是一个新组件。', '提示').then(res => {
            item.issave = false
            this.savepro()
        })
            .catch(res => {
                return
            })
    }
}
export function saveZj(id, index) {
    const data = this.scopename[index].jsondata
    this.saveProComp(data, index + 1, id, 2)
}
// 关闭查看更多弹窗
export function largeclose() {
    this.largevisible = false
}
// 更新查看更多弹窗数据
export function moredata(vdata) {
    if (vdata.length) {
        let header = vdata[0].map((item, i) => {
            return { name: item, key: `value${i + 1}` }
        })
        let valuedata = vdata.slice(1).map(item => {
            let newitem = {}
            header.forEach((del, i) => {
                newitem[del.key] = item[i]
            })
            return newitem
        })
        const dataconfig = {
            header: header,
            list: valuedata
        }
        const logdata = {
            project_id: this.proid,
            component_index: this.activescope + 1,
            page: 1,
            config_json: JSON.stringify(dataconfig),
            totalpage: 1,
        }
        this.scopename[this.activescope].ismore = true
        prologdataupdate(logdata)
    } else {
        this.scopename[this.activescope].ismore = false
    }
}
// 打开查看更多弹窗
export function tomore(i) {
    const proparams = {
        page: 1,
        project_id: this.proid,
        component_index: i + 1,
    }
    var vname = this.$route.name
    let axioss = getprologdata
    if (vname == 'share') {
        axioss = getprologdatashare
    }
    axioss(proparams).then(res => {
        this.dialogdata = JSON.parse(res.data.config_json)
        this.dialogdata.title = this.scopename[i].name
        this.largevisible = true
    })
}
// 关闭升级弹窗
export function payclose() {
    this.payvisible = false
}
// 打开升级弹窗
export function openpaylog() {
    let userinfo = JSON.parse(localStorage.getItem('userInfor'))
    if (!userinfo) return
    this.payvisible = true
}
// 获取用户等级
export function getLevelName() {
    let userinfo = JSON.parse(localStorage.getItem('userInfor'))
    const route = this.$route.path
    if (route == '/share') {
        let projectId = this.$route.query.projectId
        const params = {
            ids: projectId
        }
        getLevelByIds(params).then(res => {
            if (res.status == 200) {
                this.rolelevel = res.data.role_id
            }
        })
        return ''
    }
    if (!userinfo) {
        return '普通版'
    }
    const rolemap = {
        '-1': {name: '普通版' },
        '0': {name: '试用版' },
        '1': {name: '月费会员' },
        '2': {name: '年费会员' },
    }
    this.rolelevel = userinfo.role_id
    // [
    //     {name: '免费版' },
    //     {name: '标准版' },
    //     {name: '企业版' },
    // ]
    return rolemap[userinfo.role_id].name
}
// 获取升级/续费文本
export function getpaytext() {
    let info = JSON.parse(localStorage.getItem('userInfor'))
    if (info && info.role_id) {
        return info.role_id == 0 ? '前往升级' : '会员续费'
    }
    return '前往升级'
}
// 头部多页面方法调用
export function openHeadJump() {
    let hdom = this.$refs.temhead
    if (hdom && hdom.openjump) {
        hdom.openjump()
    }
}
// 头部配置保存
export function headsave(option) {
    this.scopename[this.scopename.length -1].vdata = option
    this.scopename = [...this.scopename]
    this.savepro()
}
// api联动方法
export function apichange(item) {
    if (item.id) {
        this.scopename.forEach((del, i) => {
            if (del.apiconfig && del.apiconfig.iscontact) {
                let nparams = {
                    id: item.id
                }
                del.apiconfig.params = { ...del.apiconfig.params, ...nparams }
            }
        })
        this.scopename = [...this.scopename]
        this.scopename.forEach((del, i) => {
            if (del && del.apiconfig) {
                const comname = 'comp' + i
                let vdom = this.$refs[comname]
                if (vdom && vdom.length) {
                    vdom = vdom[0]
                } else {
                    vdom = vdom
                }
                if (vdom && del.apiconfig.iscontact) {
                    vdom.setData()
                }
            }
        })
    }
}
// 打开项目分享弹窗
export async function sharepro(item) {
    if (!await this.getPermision(0)) {
        return;
    }
    const routeData = this.$router.resolve({
        name: 'share', // 目标路由的名称
        query: {
            projectId: item.ids,
            preview: 1,
        }
    });
    let href = window.location.origin + window.location.pathname
    this.sharelink = href + routeData.href
    this.pwd = item.pwd
    this.showshare = true
}
// 关闭项目分享弹窗
export function shareclose() {
    this.showshare = false
}
// 轮询页面是否需要加载水印
export function getWater() {
    let water = document.querySelector('.water-mark')
    if (this.rolelevel < 1 && !water) {
        const newDiv = document.createElement('div')
        newDiv.classList.add('water-mark')
        const parentNode = document.querySelector('.scale-wrap');
        if (parentNode) {
            parentNode.appendChild(newDiv)
        }
    }
}

export function beginvideo() {
    startRecording()
}